import React, { useState } from 'react';
import { useForm } from "react-hook-form";

import { Table, Button, Badge, InputGroup, InputGroupText, Input, InputGroupAddon, FormGroup, Label, Alert, Card, CardBody, CardHeader, CardTitle } from 'reactstrap';
import AdressInfo from './AdressInfo';
import AdresWithList from './AdresWithList';
import dlLogo from './../../../assets/downloadLogo.png'
import upsCarLogo from '../../../assets/UPS-Van-Back-icon.png'
import './../shipment.css'
export default function ShipmentForm({ type }) {
    const [disableTerminPicker, setDisableTerminPicker] = useState(true)
    const [responseData, setResponseData] = useState()
    const [errorMessage, setErrorMessage] = useState('')
    const [pickupRequested, setPickupRequested] = useState(false)

    //states for store and post values
    const [shipmentRef, setShipmentRef] = useState('')
    const [shipmentValue, setShipmentValue] = useState('')
    const [shipmentWeight, setShipmentWeight] = useState('2')
    const [NotificationEmailAddress, setNotificationEmailAddress] = useState('shop@zeitauktion.com')
    const [dateValue, setDateValue] = useState('')
    const [fromTime, setFromTime] = useState('')
    const [toTime, setToTime] = useState('')
    //states of address info of AdresWithList component
    //const [nameValue, setNameValue] = useState('')
    const [companyNameFirma, setCompanyNameFirma] = useState('')
    const [kontaktName, setKontaktName] = useState('')
    const [plz, setPLZ] = useState('')
    const [streetAndNr, setStreetAndNr] = useState('')
    const [adresszusatz, setAdresszusatz] = useState('')
    const [länderkürzel, setLänderkürzel] = useState('')
    const [state, setState] = useState('')
    const [city, setCity] = useState('')
    const [tel, setTel] = useState('')
    //state for response
    const [imgSrc, setImgSrc] = useState('')
    const [apiRes, setApiRes] = useState(false)
    const [apiReData, setApiResData] = useState('')

    //states of address info of AdressInfo component
    const [title, setTitle] = useState('')
    const [companyNameFirma1, setCompanyNameFirma1] = useState('')
    const [kontaktName1, setKontaktName1] = useState('')
    const [plz1, setPLZ1] = useState('')
    const [streetAndNr1, setStreetAndNr1] = useState('')
    const [adresszusatz1, setAdresszusatz1] = useState('')
    const [länderkürzel1, setLänderkürzel1] = useState('')
    const [state1, setState1] = useState('')
    const [city1, setCity1] = useState('')
    const [tel1, setTel1] = useState('')
    const [shipperNumber, setShipperNumber] = useState('')
    const [packageReferenceNumberValue, setPackageReferenceNumberValue] = useState('')

    const {
        register,
        // handleSubmit,
        watch,
        formState: { errors }
    } = useForm();

    // const onSubmit = (data) => {
    //  alert(JSON.stringify(data));
    // }; // your form submit function which will invoke after successful validation

    console.log(watch("Sendungswert")); // you can watch individual input by pass the name of the input

    const handleSubmit = async (event) => {
        // alert('Your favorite flavor is: '  );
        event.preventDefault();
        console.log(event)
        if (window.location.pathname !== ("/Shipments/receiveform" || "/Shipments/receiveForm")) {

            if (companyNameFirma1) {
                try {

                    var response = await fetch(`/Shipments/SendReceiveShipment`, {
                        method: "POST",
                        headers: new Headers({
                            "Content-Type": "application/json",
                        }),
                        body: JSON.stringify({
                            addressValidation: "validate",
                            shipperName: companyNameFirma1,
                            shipperAttentionName: kontaktName1,
                            shipperPhoneNumber: tel1,
                            shipperNumber: shipperNumber,
                            shipperAddress: streetAndNr1,
                            shipperCity: city1,
                            shipperPostalCode: plz1,
                            shipperCountryCode: länderkürzel1,
                            shipToName: companyNameFirma,
                            PickupDate: "",
                            PickupReadyTime: "",
                            PickupCloseTime: "",
                            PickupRequested: !disableTerminPicker,
                            shipToAttentionName: kontaktName,
                            shipToPhoneNumber: tel,
                            shipToAddressLine1: streetAndNr,
                            shipToAddressLine2: adresszusatz,
                            shipToAddressCity: city,
                            ShipToAddressStateProvince: state,
                            shipToAddressPostalCode: plz,
                            shipToAddressCountryCode: länderkürzel,
                            shipFromName: companyNameFirma1,
                            shipFromAttentionName: kontaktName1,
                            shipFromPhoneNumber: tel1,
                            shipFromAddressLine1: streetAndNr1,
                            shipFromAddressLine2: adresszusatz1,
                            shipFromAddressCity: city1,
                            ShipFromAddressStateProvince: state1,
                            shipFromAddressPostalCode: plz1,
                            shipFromAddressCountryCode: länderkürzel1,
                            packageDescription: "International Goods",
                            packagePackagingCode: "02",
                            packageWeightUnitOfMeasurementCode: "KGS",
                            packageWeight: shipmentWeight,
                            PackagePrice: shipmentValue,
                            packageReferenceNumberValue: packageReferenceNumberValue,
                            packageReferenceNumber: shipmentRef,
                            NotificationEmailAddress: NotificationEmailAddress,
                            CustomsDocsPath: uploadedFileUrl
                        }),
                    });
                    const payload = await response.clone().json();
                    setApiResData(payload)
                    console.log(payload)
                    if (response.ok) {
                        setImgSrc(`data:image/png;base64,${payload.graphicImage}`)
                        setApiRes(true)
                        setResponseData('')
                    }
                    if (!response.ok) {
                        const payload = await response.clone().text();
                        setResponseData(payload)
                        console.log(payload)
                    }
                } catch (e) {
                    console.log(e);
                    const payload = await response.clone().text();
                    setErrorMessage(e)
                    setResponseData(payload)
                }
            } else {
                alert('Bitte auswählen ')
            }
        } else {
            if (window.location.pathname === ("/Shipments/receiveform" || "/Shipments/receiveForm")) {
                if (companyNameFirma1) {
                    try {

                        response = await fetch(`/Shipments/SendReceiveShipment`, {
                            method: "POST",
                            headers: new Headers({
                                "Content-Type": "application/json",
                            }),
                            body: JSON.stringify({
                                addressValidation: "validate",
                                shipperName: companyNameFirma1,
                                shipperAttentionName: kontaktName1,
                                shipperPhoneNumber: tel1,
                                shipperNumber: shipperNumber,
                                shipperAddress: streetAndNr1,
                                shipperCity: city1,
                                shipperPostalCode: plz1,
                                shipperCountryCode: länderkürzel1,
                                shipToName: companyNameFirma1,
                                PickupDate: disableTerminPicker === false && dateValue !== '' ? dateValue : "",
                                PickupReadyTime: disableTerminPicker === false && fromTime !== '' ? fromTime : "",
                                PickupCloseTime: disableTerminPicker === false && toTime !== '' ? toTime : "",
                                PickupRequested: !disableTerminPicker,
                                shipToAttentionName: kontaktName1,
                                shipToPhoneNumber: tel1,
                                shipToAddressLine1: streetAndNr1,
                                shipToAddressLine2: adresszusatz1,
                                shipToAddressCity: city1,
                                ShipToAddressStateProvince: state1,
                                shipToAddressPostalCode: plz1,
                                shipToAddressCountryCode: länderkürzel1,
                                shipFromName: companyNameFirma,
                                shipFromAttentionName: kontaktName,
                                shipFromPhoneNumber: tel,
                                shipFromAddressLine1: streetAndNr,
                                shipFromAddressLine2: adresszusatz,
                                ReturnServiceCode: "9",
                                shipFromAddressCity: city,
                                ShipFromAddressStateProvince: state,
                                shipFromAddressPostalCode: plz,
                                shipFromAddressCountryCode: länderkürzel,
                                packageDescription: "International Goods",
                                packagePackagingCode: "02",
                                packageWeightUnitOfMeasurementCode: "KGS",
                                packageWeight: shipmentWeight,
                                PackagePrice: shipmentValue,
                                packageReferenceNumberValue: packageReferenceNumberValue,
                                packageReferenceNumber: shipmentRef,
                                NotificationEmailAddress: NotificationEmailAddress,
                                CustomsDocsPath: uploadedFileUrl
                            }),
                        });
                        const payload = await response.clone().json();
                        setApiResData(payload)
                        console.log(payload)
                        if (response.ok) {
                            setImgSrc(`data:image/png;base64,${payload.graphicImage}`)
                            setApiRes(true)
                            setResponseData('')
                        }
                        //throw new Error('Something went wrong');
                        if (!response.ok) {
                            const payload = await response.clone().text();
                            setResponseData(payload)
                            console.log(payload)
                            //throw new Error('Something went wrong');
                        }
                    } catch (e) {
                        //const payload = await response.json();
                        console.log(e, response);
                        const data = await response.clone().text()
                        console.log(data)
                        setErrorMessage(e.message)
                        setResponseData(data)
                    }
                } else {
                    alert('Bitte auswählen')
                }
            }
        }

    }


    // select file input (shipmentUploadedFile)
    const [input, setInput] = useState('')
    const [uploadedFileUrl, setUploadedFileUrl] = useState();


    const handleUploadFile = async () => {
        const formData = new FormData();

        formData.append('File', input);

        const response = await fetch(
            '/api/Files/Upload/customsDocument',
            {
                method: 'POST',
                body: formData,
            }
        )
        const data = await response.text()
        console.log(data)
        setUploadedFileUrl(data)
        if (response.ok) {
            setInput('')
        }
        if (!response.ok) {
            alert(`${data} upload was NOT successful, if you want to try again please reselect your file`)
            setInput('')
        }
    };


    return (
        <div className='ml-3 mt-5 mr-5 container'>
            <Button onClick={() => window.location.reload()} outline className='d-inline-flex align-items-center'>
                {console.log(window.location.href)}
                {console.log(window.location.pathname)}
                {window.location.pathname === ("/Shipments/receiveform" || "/Shipments/receiveForm") ? <><h3>Rückholung eines Pakets</h3> <img className='ml-2' style={{ height: "100px" }} src={upsCarLogo} alt='ups logo' /> </> : <><h3>Sendung eines Pakets</h3> <img className='ml-2' style={{ height: "100px" }} src={upsCarLogo} alt='ups logo' /></>}
            </Button>
            <form style={apiRes ? { display: "none" } : {}}
                // onSubmit={handleSubmit(onSubmit)}
                onSubmit={handleSubmit}
            >
                <hr className='mr-5'></hr>
                <div className='input d-flex justify-content-between mb-2'>
                    <InputGroup className="mr-4 w-100">
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText>Sendungsreferenz:</InputGroupText>
                        </InputGroupAddon>
                        <Input
                            required
                            {...register("Sendungsreferenz", {
                                required: true,
                                maxLength: 20,
                                pattern: /^[A-Za-z]+$/i
                            })}
                            value={shipmentRef || ''}
                            onChange={(e) => { setShipmentRef(e.target.value); console.log(shipmentRef) }}
                        />

                        {errors?.Sendungsreferenz?.type === "required" && <p>This field is required</p>}
                        {errors?.Sendungsreferenz?.type === "maxLength" && (
                            <p>First name cannot exceed 20 characters</p>
                        )}
                        {errors?.Sendungsreferenz?.type === "pattern" && (
                            <p>Alphabetical characters only</p>
                        )}
                    </InputGroup>
                    <InputGroup className="mr-4 w-75">
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText>Sendungswert:</InputGroupText>
                        </InputGroupAddon>
                        <Input required type="number"
                            min="10"  {...register("Sendungswert", { min: 10, max: 99999 })}
                            value={shipmentValue}
                            onChange={(e) => { setShipmentValue(e.target.value) }}
                        />
                        <InputGroupAddon addonType="append">
                            <InputGroupText>€</InputGroupText>
                        </InputGroupAddon>
                        {errors.Sendungswert && (
                            <p>Minimum is 100 and maximum is 99999</p>
                        )}
                    </InputGroup>
                    <InputGroup className="w-50">
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText>Gewicht:</InputGroupText>
                        </InputGroupAddon>
                        <Input style={{ maxWidth: '60px' }} required type="number" min="0.1" max="99" step=".01"
                            value={shipmentWeight}
                            onChange={(e) => { setShipmentWeight(e.target.value); console.log(shipmentWeight) }}
                        />
                        <InputGroupAddon addonType="append">
                            <InputGroupText>kg</InputGroupText>
                        </InputGroupAddon>
                    </InputGroup>
                </div>
                <div className='mb-4 mr-5'>
                    <InputGroup className="mr-5">
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText>Label-Empfänger:</InputGroupText>
                        </InputGroupAddon>
                        <Input
                            value={NotificationEmailAddress}
                            onChange={(e) => { setNotificationEmailAddress(e.target.value); console.log(NotificationEmailAddress) }}
                        />
                    </InputGroup>
                </div>
                <hr className='mr-5'></hr>

                <FormGroup tag="fieldset" className='d-flex justify-content-between align-items-center mr-5'>
                    <Badge color="info"><h4>Absender:</h4></Badge>
                    <FormGroup check>
                        <Label check style={window.location.pathname === ("/Shipments/receiveform" || "/Shipments/receiveForm") ? { visibility: "visible" } : { visibility: "hidden" }}>
                            <Input type="radio" name="abgabe" defaultChecked onClick={e => setDisableTerminPicker(true)} />{' '}
                            Abgabe im UPS Point
                        </Label>
                    </FormGroup>
                    <FormGroup check>
                        <Label check style={window.location.pathname === ("/Shipments/receiveform" || "/Shipments/receiveForm") ? { visibility: "visible" } : { visibility: "hidden" }}>
                            <Input type="radio" name="abgabe" onClick={e => setDisableTerminPicker(false)} />{' '}
                            Abholung durch UPS zum Termin
                        </Label>
                    </FormGroup>
                    <FormGroup check style={{ visibility: "hidden" }}>
                        <Label check>
                            <Input type="checkbox" />{' '}
                            <b>One-Time link</b>
                        </Label>
                    </FormGroup>
                </FormGroup>

                <div className='input d-flex justify-content-between mr-5 mb-1'>
                    <InputGroup className="mr-5 w-75" style={window.location.pathname === ("/Shipments/receiveform" || "/Shipments/receiveForm") ? { display: "flex" } : { display: "none" }}>
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText>Abholdatum:</InputGroupText>
                        </InputGroupAddon>
                        <Input disabled={disableTerminPicker} type="date"
                            {...register("Abholdatum", {
                                // required: true,
                                // maxLength: 20,
                                // pattern: /^[A-Za-z]+$/i
                            })}
                            value={dateValue || ''}
                            onChange={(e) => { setDateValue(e.target.value) }}
                        />
                        {errors?.Abholdatum?.type === "required" && <p>This field is required</p>}
                        {errors?.Abholdatum?.type === "maxLength" && (
                            <p>First name cannot exceed 20 characters</p>
                        )}
                        {errors?.Abholdatum?.type === "pattern" && (
                            <p>Alphabetical characters only</p>
                        )}
                    </InputGroup>
                    <InputGroup className="mr-5 w-50" style={window.location.pathname === ("/Shipments/receiveform" || "/Shipments/receiveForm") ? { display: "flex" } : { display: "none" }}>
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText>Abholzeitraum von:</InputGroupText>
                        </InputGroupAddon>
                        <Input disabled={disableTerminPicker} type="time" {...register("von",)}
                            value={fromTime || ''}
                            onChange={(e) => { setFromTime(e.target.value) }}
                        />
                        {errors.von && (
                            <p>Minimum is 0 and maximum is 99999</p>
                        )}
                    </InputGroup>
                    <InputGroup className="w-25" style={window.location.pathname === ("/Shipments/receiveform" || "/Shipments/receiveForm") ? { display: "flex" } : { display: "none" }}>
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText>bis:</InputGroupText>
                        </InputGroupAddon>
                        <Input disabled={disableTerminPicker} type="time"
                            value={toTime || ''}
                            onChange={(e) => { setToTime(e.target.value); console.log(toTime) }}
                        />
                    </InputGroup>
                </div>

                {window.location.pathname === ("/Shipments/receiveform" || "/Shipments/receiveForm") ? <AdresWithList
                    companyNameFirma={companyNameFirma}
                    setCompanyNameFirma={setCompanyNameFirma}
                    kontaktName={kontaktName}
                    setKontaktName={setKontaktName}
                    plz={plz}
                    setPLZ={setPLZ}
                    streetAndNr={streetAndNr}
                    setStreetAndNr={setStreetAndNr}
                    adresszusatz={adresszusatz}
                    setAdresszusatz={setAdresszusatz}
                    länderkürzel={länderkürzel}
                    setLänderkürzel={setLänderkürzel}
                    state={state}
                    setState={setState}
                    city={city}
                    setCity={setCity}
                    tel={tel}
                    setTel={setTel}
                ></AdresWithList> :
                    <AdressInfo
                        title={title}
                        setTitle={setTitle}
                        companyNameFirma1={companyNameFirma1}
                        setCompanyNameFirma1={setCompanyNameFirma1}
                        kontaktName1={kontaktName1}
                        setKontaktName1={setKontaktName1}
                        plz1={plz1}
                        setPLZ1={setPLZ1}
                        streetAndNr1={streetAndNr1}
                        setStreetAndNr1={setStreetAndNr1}
                        adresszusatz1={adresszusatz1}
                        setAdresszusatz1={setAdresszusatz1}
                        länderkürzel1={länderkürzel1}
                        setLänderkürzel1={setLänderkürzel1}
                        state1={state1}
                        setState1={setState1}
                        city1={city1}
                        setCity1={setCity1}
                        tel1={tel1}
                        setTel1={setTel1}
                        shipperNumber={shipperNumber}
                        setShipperNumber={setShipperNumber}
                        packageReferenceNumberValue={packageReferenceNumberValue}
                        setPackageReferenceNumberValue={setPackageReferenceNumberValue}
                    ></AdressInfo>}
                <hr className='mr-5'></hr>
                <Badge color="info" style={window.location.pathname === ("/Shipments/receiveform" || "/Shipments/receiveForm") ? { marginBottom: "16px" } : {}}><h4>Empfänger:</h4></Badge>
                {window.location.pathname === ("/Shipments/receiveform" || "/Shipments/receiveForm") ? <AdressInfo
                    title={title}
                    setTitle={setTitle}
                    companyNameFirma1={companyNameFirma1}
                    setCompanyNameFirma1={setCompanyNameFirma1}
                    kontaktName1={kontaktName1}
                    setKontaktName1={setKontaktName1}
                    plz1={plz1}
                    setPLZ1={setPLZ1}
                    streetAndNr1={streetAndNr1}
                    setStreetAndNr1={setStreetAndNr1}
                    adresszusatz1={adresszusatz1}
                    setAdresszusatz1={setAdresszusatz1}
                    länderkürzel1={länderkürzel1}
                    setLänderkürzel1={setLänderkürzel1}
                    state1={state1}
                    setState1={setState1}
                    city1={city1}
                    setCity1={setCity1}
                    tel1={tel1}
                    setTel1={setTel1}
                    shipperNumber={shipperNumber}
                    setShipperNumber={setShipperNumber}
                    packageReferenceNumberValue={packageReferenceNumberValue}
                    setPackageReferenceNumberValue={setPackageReferenceNumberValue}
                ></AdressInfo>
                    :
                    <AdresWithList
                        companyNameFirma={companyNameFirma}
                        setCompanyNameFirma={setCompanyNameFirma}
                        kontaktName={kontaktName}
                        setKontaktName={setKontaktName}
                        plz={plz}
                        setPLZ={setPLZ}
                        streetAndNr={streetAndNr}
                        setStreetAndNr={setStreetAndNr}
                        adresszusatz={adresszusatz}
                        setAdresszusatz={setAdresszusatz}
                        länderkürzel={länderkürzel}
                        setLänderkürzel={setLänderkürzel}
                        state={state}
                        setState={setState}
                        city={city}
                        setCity={setCity}
                        tel={tel}
                        setTel={setTel}
                    ></AdresWithList>}
                <hr className='mr-5'></hr>
                <div className='d-flex justify-content-between mr-5'>
                    <div style={{ visibility: 'visible' }}>
                        <label className='mr-1'>Custom declaration file: </label>
                        <input type="file" id="shipmentUploadedFile" name="filename"
                            onChange={(e) => { setInput(e.target.files[0]); }}
                        ></input>
                        {input &&
                            <Button
                                color="success"
                                onClick={handleUploadFile}
                            >Upload</Button>
                        }
                    </div>
                    {
                        <input className="btn btn-success" type="submit" value='Fertig' disabled={input}
                        // onClick={() => { postSendReceiveShipment() }} 
                        />
                    }
                </div>
            </form>
            <div style={responseData ? { display: 'block' } : { display: 'none' }}>
                <Alert className='mt-3 mb-3 mr-5' color="danger">
                    response data: <code><b>{JSON.stringify(responseData)}</b></code>
                </Alert>
                <br />
                {errorMessage ? `catch error message: ${errorMessage}` : ''}

            </div>
            <div className='mt-5 mb-5' style={apiRes === false ? { visibility: 'hidden' } : {}} >
                <Card>
                    <CardHeader tag='h4' className='d-flex' color='info'><CardTitle> Your parcel has been <span className='animate-charcter'>scheduled</span></CardTitle>
                        {/**  <a className='ml-5' href={imgSrc ? imgSrc : '#'} download>
                            <Button className='d-flex justify-content-around align-items-center' style={{ width: '300px' }} color='success'>
                                <i className="fas fa-download"></i>
                                Download label
                                <i className="fas fa-download"></i>
                            </Button>
                        </a>  */}
                    </CardHeader>
                    <CardBody>
                        <>
                            <Table striped className='mr-5 w-50 d-inline w-50 align-top' >
                                <tbody>
                                    <tr>
                                        <td>Tracking ID:</td>
                                        <td>{apiReData.shipmentInfo ? apiReData.shipmentInfo.TrackingNumber : ''}</td>
                                    </tr>
                                    <tr>
                                        <td>Name:</td>
                                        {console.log(apiReData)}
                                        {apiReData.shipmentInfo &&
                                            <td>{apiReData.shipmentInfo && (window.location.pathname === ("/Shipments/receiveform" || "/Shipments/receiveForm")) ? apiReData.shipmentInfo.ShipFromName : apiReData.shipmentInfo.ShipToName}</td>
                                        }
                                    </tr>
                                    <tr>
                                        <td>Attention Name:</td>
                                        {apiReData.shipmentInfo &&
                                            <td>{apiReData.shipmentInfo && (window.location.pathname === ("/Shipments/receiveform" || "/Shipments/receiveForm")) ? apiReData.shipmentInfo.ShipFromAttentionName : apiReData.shipmentInfo.ShipToAttentionName}</td>
                                        }
                                    </tr>
                                    <tr>
                                        <td>Phone No.:</td>
                                        {apiReData.shipmentInfo &&
                                            <td>{apiReData.shipmentInfo && (window.location.pathname === ("/Shipments/receiveform" || "/Shipments/receiveForm")) ? apiReData.shipmentInfo.ShipFromPhoneNumber : apiReData.shipmentInfo.ShipToPhoneNumber}</td>
                                        }
                                    </tr>
                                    <tr>
                                        <td>Address Line 1:</td>
                                        {apiReData.shipmentInfo &&
                                            <td>{apiReData.shipmentInfo && (window.location.pathname === ("/Shipments/receiveform" || "/Shipments/receiveForm")) ? apiReData.shipmentInfo.ShipFromAddressLine1 : apiReData.shipmentInfo.ShipToAddressLine1}</td>
                                        }
                                    </tr>
                                    <tr>
                                        <td>Address Line 2:</td>
                                        {apiReData.shipmentInfo &&
                                            <td>{apiReData.shipmentInfo && (window.location.pathname === ("/Shipments/receiveform" || "/Shipments/receiveForm")) ? apiReData.shipmentInfo.ShipFromAddressLine2 : apiReData.shipmentInfo.ShipToAddressLine2}</td>
                                        }
                                    </tr>
                                    <tr>
                                        <td>Post Code:</td>
                                        {apiReData.shipmentInfo &&
                                            <td>{apiReData.shipmentInfo && (window.location.pathname === ("/Shipments/receiveform" || "/Shipments/receiveForm")) ? apiReData.shipmentInfo.ShipFromAddressPostalCode : apiReData.shipmentInfo.ShipToAddressPostalCode}</td>
                                        }
                                    </tr>
                                    <tr>
                                        <td>City:</td>
                                        {apiReData.shipmentInfo &&
                                            <td>{apiReData.shipmentInfo && (window.location.pathname === ("/Shipments/receiveform" || "/Shipments/receiveForm")) ? apiReData.shipmentInfo.ShipFromAddressCity : apiReData.shipmentInfo.ShipToAddressCity}</td>
                                        }
                                    </tr>
                                    <tr>
                                        <td>Country:</td>
                                        {apiReData.shipmentInfo &&
                                            <td>{apiReData.shipmentInfo && (window.location.pathname === ("/Shipments/receiveform" || "/Shipments/receiveForm")) ? apiReData.shipmentInfo.ShipFromAddressCountryCode : apiReData.shipmentInfo.ShipToAddressCountryCode}</td>
                                        }
                                    </tr>
                                    <tr>
                                        <td>Pick-up PRN:</td>
                                        <td>{apiReData.shipmentInfo ? apiReData.pickupInfoPRN : ''}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2" style={{ height: "200px", textAlign: "center", verticalAlign: "middle" }}>

                                            <a className='' href={imgSrc ? imgSrc : '#'} style={{ display: 'block' }} download>
                                                <img src={dlLogo} alt="downloadLogo" />
                                            </a>
                                            <a className='' href={imgSrc ? imgSrc : '#'} style={{ display: 'block' }} download>
                                                Download label
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>

                        </>
                        <a href={imgSrc ? imgSrc : '#'} download>
                            {apiRes && <img style={{ height: '900px' }} className='img img-thumbnail lableImg' src={imgSrc} alt='nothing' />}
                        </a>
                    </CardBody>
                </Card>
            </div>
        </div>
    );
}